import {UIGameManager} from '../UIGameManager'
import {UIGameMapMetropolisController} from '../ui_game_map/UIGameMapMetropolisController'
import {UIGameCityImprovementAchievementController} from './UIGameCityImprovementAchievementController'
import {UIGameMetropolisAchievementController} from './UIGameMetropolisAchievementController'
import {MechanicCityImprovementsState, MechanicRobberState} from '@colonist/game-states'
import {MechanicValidatorCityImprovements} from '@colonist/game-mechanic-validators'

export class UIGameCityImprovement {
    protected readonly uiGameManager: UIGameManager
    protected readonly cityImprovementsState: MechanicCityImprovementsState
    protected readonly cityImprovementsValidator: MechanicValidatorCityImprovements

    constructor(uiGameManager: UIGameManager, cityImprovementsState: MechanicCityImprovementsState, robberState: MechanicRobberState | undefined) {
        this.uiGameManager = uiGameManager
        this.cityImprovementsState = cityImprovementsState
        this.cityImprovementsValidator = new MechanicValidatorCityImprovements(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.cityImprovementsState)

        new UIGameMapMetropolisController(this.uiGameManager, robberState)
        new UIGameMetropolisAchievementController(this.uiGameManager, this.cityImprovementsValidator)
        new UIGameCityImprovementAchievementController(this.uiGameManager, this.cityImprovementsValidator.getPlayerCityImprovementsState(this.uiGameManager.gameController.myColor))
    }
}
